// ── IMAGE SLOTS (Martial Arts Kids Class Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = '2f1b33cd-1283-4de9-b23d-d22d221113ea';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 4 and 8 on the iMac, and the Impultienda bonus photos with their titles typed in. Pure white background.
 */
const IMAC = RES + '1792611837302_mak-mockup-imac-a0b1c302.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.4, 11, 12, 13, 36, 39
 *  (pages checked clean in QC; p.10 has a typo and p.40 a wrong class list, so they are not shown). */
export const pageImages: string[] = [
  RES + '1792611880699_mak-pagina-04-plan-q1-a61a6181.webp',
  RES + '1792612197233_mak-pagina-11-clase-02-plan-11c623b7.webp',
  RES + '1792612201539_mak-pagina-12-clase-02-teach-c7c4f20e.webp',
  RES + '1792612205874_mak-pagina-13-clase-02-drills-f278e2b7.webp',
  RES + '1792612210298_mak-pagina-36-clase-10-estaciones-8f3e63de.webp',
  RES + '1792612214849_mak-pagina-39-planner-10b1c578.webp',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792611841876_mak-bono-1-juegos-f74409e6.webp',
  RES + '1792611845597_mak-bono-2-cinturon-bf90785e.webp',
  RES + '1792611849893_mak-bono-3-padres-3136d93b.webp',
  RES + '1792611853307_mak-bono-4-pads-acf98304.webp',
  RES + '1792611856876_mak-bono-5-prueba-a3ddb784.webp',
];
